import { combineReducers } from 'redux'
import { patientLogin } from './patient/patientLoginReducer'
import { patientRegister } from './patient/patientRegisterReducer'
import { doctorLogin } from './doctor/doctorLoginReducer'
import { doctorRegister } from './doctor/doctorRegisterReducer'
import { hospitalLogin } from './hospital/hospitalLoginReducer'
import { hospitalRegister } from './hospital/hospitalRegisterReducer'

const authReducers = combineReducers({
  patientLogin,
  patientRegister,
  doctorLogin,
  doctorRegister,
  hospitalLogin,
  hospitalRegister,
})

export default authReducers
